// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1DrLn","inner":"Form_inner__1MEBs","range":"Form_range__3pXd4","name":"Form_name__3tdqE","actions":"Form_actions__2w1C2"};